// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"696b0ce0","453":"fa178f2b","455":"f2dc8bf6","977":"17257424"}[chunkId] + ".chunk.js";
};